export default __webpack_public_path__ + "static/media/img2.499ca8db.jpg";